export default function Faq() {
  return (
    <>
      <h1>FAQ</h1>
      <p>Q: Where is the native app?</p>
      <p>A: There isn't one. However, this app is a PWA (Progressive Web App), so you can install and use it as if it's a native app by adding it to your home screen!</p>
    </>
  )
}
